import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="stores--admins"
export default class extends Controller {
  static targets = ["availableAdminsSelect"];

  connect() {
    if (this.availableAdminsSelectTarget.tomselect) return;
    this.availableAdminsSelect = new TomSelect(
      this.availableAdminsSelectTarget
    );
  }

  disconnect() {
    if (this.availableAdminsSelect) {
      this.availableAdminsSelect.destroy();
      this.availableAdminsSelect = null;
    }
  }
}
